import React, { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';

import Button from 'src/components/ui/button';
import { ReactComponent as CheckCircle } from 'src/assets/icons/check-circle.svg';

import cartStore from 'src/stores/cart-store';
import globalStore from 'src/stores/global-store';
import paymentStore from 'src/stores/payment-store';

import { AppRoute, CNAME, LOCALES } from 'src/constants';

import './payment-result-page.scss';

const PaymentResultPage = observer(() => {
  const { id } = useParams();
  const { decedent, queryParams, isNoSlug } = globalStore;
  const { paidOrderNumber } = paymentStore;

  const buttonLabel = isNoSlug ? LOCALES.BACK_TO_MAIN_PAGE : LOCALES.BACK_TO_RECORD_PAGE;
  const buttonLink = isNoSlug ? CNAME : decedent.link;

  useEffect(() => {
    if (paidOrderNumber) {
      cartStore.cleanCart();
    }
  }, [paidOrderNumber]);

  if (!paidOrderNumber || id !== paidOrderNumber) {
    return <Navigate to={`${AppRoute.MAIN_PAGE_ROUTE}?${queryParams}`} />;
  }

  return (
    <div className="payment-result-page">
      <div className="payment-result-page__content">
        <div className="payment-result-page__info">
          <div className="payment-result-page__icon">
            <CheckCircle />
          </div>
          <div className="payment-result-page__order">
            <div className="payment-result-page__order-info">
              <h1 className="payment-result-page__order-title">{LOCALES.ORDER_CREATED}</h1>
              <span className="payment-result-page__order-number">
                {LOCALES.ORDER_NUMBER}: {paidOrderNumber}
              </span>
            </div>
            <p className="payment-result-page__order-text">{LOCALES.ORDER_DETAILS_WILL_BE_SENT}</p>
          </div>
        </div>
        <Button
          className="payment-result-page__button"
          label={buttonLabel}
          href={buttonLink}
          size="oversize"
          tag="a"
          target="_self"
          theme="outlined"
        />
      </div>
    </div>
  );
});

export default PaymentResultPage;
